import { Box, Typography } from "@material-ui/core";
import {
  BannerSeverity,
  Icon,
  IconName,
  NotificationBanner,
  useDeviceTypes,
} from "halifax";
import clsx from "clsx";
import React from "react";
import { ReshopSuccessBannerConnectorProps } from "./container";
import { RESHOP_SUCCESS_SUBTITLE, RESHOP_SUCCESS_TITLE } from "./textConstants";
import "./styles.scss";

export type IReshopSuccessBannerProps = ReshopSuccessBannerConnectorProps;

export const ReshopSuccessBanner = ({
  showReshopSuccessBanner,
  dismissReshopSuccessBanner,
}: IReshopSuccessBannerProps) => {
  const { matchesMobile } = useDeviceTypes();

  if (!showReshopSuccessBanner) return null;

  return (
    <NotificationBanner
      className={clsx("reshop-success-banner", { mobile: matchesMobile })}
      // halifax styles error/warning/notice/improvement/neutral_info — the
      // default INFO severity renders unstyled.
      severity={BannerSeverity.NOTICE}
      icon={<Icon name={IconName.InfoCircleFill} />}
      content={
        <Box className="reshop-success-banner-content">
          <Typography variant="body2" className="reshop-success-banner-title">
            {RESHOP_SUCCESS_TITLE}
          </Typography>
          <Typography variant="body2">{RESHOP_SUCCESS_SUBTITLE}</Typography>
        </Box>
      }
      onDismiss={dismissReshopSuccessBanner}
    />
  );
};
